import type { AnswersRequest, QuestionApi } from '@webapp/survey/src/api/queries-api';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../../entities/response-machine';

export abstract class QuestionSimpleApi implements Partial<QuestionApi> {
    public change(question: QuestionContext, evt: ResponseEventParams): void {
        const { value, questionId } = evt;
        const response = question.responseActor;
        response.send({ type: 'CHANGE', value, questionId });
    }

    public changeExtra(question: QuestionActor, value: PrimitiveValue): void {
        const { response } = question.getSnapshot().context;
        response.send({ type: 'CHANGE_EXTRA', value });
    }

    public abstract query(q: QuestionActor): AnswersRequest;

    public validate(question: QuestionContext): boolean {
        const {
            params: { required },
            responseActor: responseRaw,
        } = question;
        const response = responseRaw.getSnapshot().context;

        if (required) {
            return !!response.value;
        }

        return true;
    }
}
